<table>
  <thead>
    <section id="heading">
      <app-field [document]="document.Seller" path="SellerName.value"></app-field>
      <app-field [document]="document.Seller.SellerPostalAddress" path="AddressLine1.value"></app-field>
      <app-field [document]="document.Seller.SellerPostalAddress" path="AddressLine2.value"></app-field>
      <app-field [document]="document.Seller.SellerPostalAddress" path="AddressLine3.value"></app-field>
      <span class="inline">
        <app-field [document]="document.Seller.SellerPostalAddress" path="PostCode.value"></app-field>
        <app-field [document]="document.Seller.SellerPostalAddress" path="City.value"></app-field>
      </span>
      <app-field [document]="document.Seller.SellerPostalAddress" path="CountryCode.value" i18nNamespace="ISO3166"></app-field>
    </section>

  </thead>
  <tbody>
    <section class="header">
      <div class="block">
        <div class="section-title" i18n="@@einvoice.header.invoice-address.title">Invoice Address</div>
        <app-field [document]="document" path="Buyer.BuyerName.value"></app-field>
        <app-field [document]="document" path="Buyer.BuyerTradingName.value"></app-field>
        <app-field [document]="document.Buyer.BuyerPostalAddress" path="AddressLine1.value"></app-field>
        <app-field [document]="document.Buyer.BuyerPostalAddress" path="AddressLine2.value"></app-field>
        <app-field [document]="document.Buyer.BuyerPostalAddress" path="AddressLine3.value"></app-field>
        <div class="inline">
          <app-field [document]="document.Buyer.BuyerPostalAddress" path="PostCode.value"></app-field>
          <app-field [document]="document.Buyer.BuyerPostalAddress" path="City.value"></app-field>
        </div>
        <app-field [document]="document.Buyer.BuyerPostalAddress" path="CountrySubdivision.value"></app-field>
        <app-field [document]="document.Buyer.BuyerPostalAddress" path="CountryCode.value" i18nNamespace="ISO3166"></app-field>
        <app-field [document]="document" path="Buyer.BuyerElectronicAddress.value"></app-field>
      </div>

      @if (showHeaderDeliveryAddress()) {
        <div class="block">
          <div class="section-title" i18n="@@einvoice.header.delivery-address.title">Delivery Address | Service Address | Service recipient</div>
          <app-field [document]="document" path="DeliveryInformation.DeliverToPartyName.value"></app-field>
          <app-field [document]="document.DeliveryInformation" path="DeliverToAddress.AddressLine1.value"></app-field>
          <app-field [document]="document.DeliveryInformation" path="DeliverToAddress.AddressLine2.value"></app-field>
          <app-field [document]="document.DeliveryInformation" path="DeliverToAddress.AddressLine3.value"></app-field>
          <div class="inline">
            <app-field [document]="document.DeliveryInformation" path="DeliverToAddress.PostCode.value"></app-field>
            <app-field [document]="document.DeliveryInformation" path="DeliverToAddress.City.value"></app-field>
          </div>
          <div class="inline">
            <app-field [document]="document.DeliveryInformation" path="DeliverToAddress.CountrySubdivision.value"></app-field>
            <app-field [document]="document.DeliveryInformation" path="DeliverToAddress.CountryCode.value" i18nNamespace="ISO3166"></app-field>
          </div>
          @if (hasValue(document.DeliveryInformation.DeliverToLocationIdentifier)) {
            <div class="inline">
              <span i18n="@@einvoice.header.delivery-address.deliver-to-location-identifier.label">Delivery location identifier:</span>
              <app-field [document]="document" path="DeliveryInformation.DeliverToLocationIdentifier.value"></app-field>
            </div>
          }
        </div>
      }
    </section>

    @if (hasValue(document.SellerTaxRepresentative) || hasValue(document.Payee)) {
      <section class="header">
        @if (hasValue(document.SellerTaxRepresentative)) {
          <div class="block">
            <div class="section-title" i18n="@@einvoice.header.tax-agent-address.title">Tax Agent Address</div>
            <app-field [document]="document.SellerTaxRepresentative" path="SellerTaxRepresentativeName.value"></app-field>
            <app-field [document]="document.SellerTaxRepresentative" path="SellerTaxRepresentativePostalAddress.AddressLine1.value"></app-field>
            <app-field [document]="document.SellerTaxRepresentative" path="SellerTaxRepresentativePostalAddress.AddressLine2.value"></app-field>
            <app-field [document]="document.SellerTaxRepresentative" path="SellerTaxRepresentativePostalAddress.AddressLine3.value"></app-field>
            <div class="inline">
              <app-field [document]="document.SellerTaxRepresentative" path="SellerTaxRepresentativePostalAddress.PostCode.value"></app-field>
              <app-field [document]="document.SellerTaxRepresentative" path="SellerTaxRepresentativePostalAddress.City.value"></app-field>
            </div>
            <app-field [document]="document.SellerTaxRepresentative" path="SellerTaxRepresentativePostalAddress.CountrySubdivision.value"></app-field>
            <app-field [document]="document.SellerTaxRepresentative" path="SellerTaxRepresentativePostalAddress.CountryCode.value" i18nNamespace="ISO3166"></app-field>
            <app-field [document]="document.SellerTaxRepresentative" path="SellerTaxRepresentativeVATIdentifier.value"></app-field>
          </div>
        }
        @if (hasValue(document.Payee)) {
          <div class="block">
            <div class="section-title" i18n="@@einvoice.header.payee.title">Payee</div>
            <app-field [document]="document.Payee" path="PayeeName.value"></app-field>
            <app-field [document]="document.Payee" path="PayeeIdentifier.value"></app-field>
            <app-field [document]="document.Payee" path="PayeeLegalRegistrationIdentifier.value"></app-field>
          </div>
        }
      </section>
    }

    <h2>
      <app-field [document]="document" path="InvoiceTypeCode.value" [i18nNamespace]="['UNCL1001-cn', 'UNCL1001-inv']" prefix="{{erechnungPrefix}}"></app-field>
    </h2>

    <section class="header">
      <div>
        <div class="field-with-label">
          <div class="label" i18n="@@einvoice.header.labels.number">Number</div>
          <app-field [document]="document" path="InvoiceNumber.value"></app-field>
        </div>
        <div class="field-with-label">
          <div class="label" i18n="@@einvoice.header.labels.customer-number">Customer Number</div>
          <app-field [document]="document.Buyer" path="BuyerIdentifier.value"></app-field>
        </div>
        @if (document.Seller?.SellerIdentifier?.value || document.Seller?.SellerLegalRegistrationIdentifier?.value) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.supplier-reference">Supplier Reference</div>
            <div class="inline">
              <app-field [document]="document.Seller" path="SellerIdentifier.value"></app-field>
              <app-field [document]="document.Seller" path="SellerLegalRegistrationIdentifier.value"></app-field>
            </div>
          </div>
        }
        <div class="field-with-label">
          <div class="label" i18n="@@einvoice.header.labels.contact-person">Contact Person</div>
          <app-field [document]="document.Buyer.BuyerContact" path="ContactPoint.value"></app-field>
        </div>
        @if (document?.Buyer?.BuyerContact?.ContactTelephoneNumber) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.phone">Phone</div>
            <app-field [document]="document.Buyer.BuyerContact" path="ContactTelephoneNumber.value"></app-field>
          </div>
        }
        @if (document?.Buyer?.BuyerContact?.ContactEMailAddress) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.mail">E-Mail</div>
            <app-field [document]="document.Buyer.BuyerContact" path="ContactEMailAddress.value" [renderAsEmail]="true" [emailSubject]="getEmailSubject()"></app-field>
          </div>
        }
        @if (document?.Buyer?.BuyerVATIdentifier?.value) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.your-tax-id">Your TAX ID</div>
            <app-field [document]="document.Buyer" path="BuyerVATIdentifier.value"></app-field>
          </div>
        }
        @if (document?.DeliveryInformation?.InvoicingPeriod?.InvoicingPeriodStartDate?.value || document?.DeliveryInformation?.InvoicingPeriod?.InvoicingPeriodEndDate?.value) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.performance-period">Performance Period</div>
            <div class="inline">
              <app-field [document]="document" path="DeliveryInformation.InvoicingPeriod.InvoicingPeriodStartDate.value" [dateFormat]="dateFormat"></app-field>
              @if (document?.DeliveryInformation?.InvoicingPeriod) {
                <span> - </span>
              }
              <app-field [document]="document" path="DeliveryInformation.InvoicingPeriod.InvoicingPeriodEndDate.value" [dateFormat]="dateFormat"></app-field>
            </div>
          </div>
        }
        <div class="field-with-label">
          <div class="label"></div>
          <app-field [document]="document" path=""></app-field>
        </div>
        <div class="field-with-label">
          <div class="label" i18n="@@einvoice.header.labels.reference">Reference</div>
          <app-field [document]="document" path="BuyerReference.value"></app-field>
        </div>

      </div>

      <div>
        <div class="field-with-label">
          <div class="label" i18n="@@einvoice.header.labels.date">Date</div>
          <app-field [document]="document" path="InvoiceIssueDate.value" [dateFormat]="dateFormat"></app-field>
        </div>
        @if (document?.ValueAddedTaxPointDate) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.vat-date">VAT Date</div>
            <app-field [document]="document" path="ValueAddedTaxPointDate.value" [dateFormat]="dateFormat"></app-field>
          </div>
        }
        @if (document?.DeliveryInformation?.ActualDeliveryDate?.value) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.delivery-date">Delivery Date</div>
            <app-field [document]="document.DeliveryInformation" path="ActualDeliveryDate.value" [dateFormat]="dateFormat"></app-field>
          </div>
        }
        <!-- Removed as of #10
        <div class="field-with-label">
          <div class="label" i18n="@@einvoice.header.labels.vat-date-code">VAT Date Code</div>
          <app-field [document]="document" path="ValueAddedTaxPointDateCode.value" [dateFormat]="dateFormat"></app-field>
        </div> -->
        @if (document?.Seller?.SellerContact?.ContactPoint?.value) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.person-in-charge">Person in Charge</div>
            <app-field [document]="document" path="Seller.SellerContact.ContactPoint.value"></app-field>
          </div>
        }
        @if (document?.Seller?.SellerContact?.ContactTelephoneNumber?.value) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.phone">Phone</div>
            <app-field [document]="document" path="Seller.SellerContact.ContactTelephoneNumber.value"></app-field>
          </div>
        }
        @if (document?.Seller?.SellerContact?.ContactEMailAddress?.value) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.mail">E-Mail</div>
            <app-field [document]="document" path="Seller.SellerContact.ContactEMailAddress.value" [renderAsEmail]="true" [emailSubject]="getEmailSubject()"></app-field>
          </div>
        }
        @if (false) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.delivery-terms">Delivery Terms</div>
            <app-field [document]="document" path=""></app-field>
          </div>
        }
        @if (false) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.header.labels.shipping-condition">Shipping Condition</div>
            <app-field [document]="document" path=""></app-field>
          </div>
        }
        <div class="field-with-label">
          <div class="label" i18n="@@einvoice.header.labels.due-date">Due Date</div>
          <app-field [document]="document" path="PaymentDueDate.value" [dateFormat]="dateFormat"></app-field>
        </div>
      </div>
    </section>
    <section id="lineitems">
      <table>
        <thead class="border-bottom">
          <tr>
            <th class="index"></th>
            <th class="description" i18n="@@einvoice.table.header.item-description">Item Description</th>
            <th class="qty ellipsis" i18n="@@einvoice.table.header.quantity">Quantity</th>
            <th class="unit" i18n="@@einvoice.table.header.unit">Unit</th>
            <th class="unit-price ellipsis">
              <span i18n="@@einvoice.table.header.unit-price">Unit Price</span>
              <app-field class="ml-1" [document]="document" path="InvoiceCurrencyCode.value"></app-field>
            </th>
            <th class="total ellipsis">
              <span i18n="@@einvoice.table.header.total">Total</span>
              <app-field class="ml-1" [document]="document" path="InvoiceCurrencyCode.value"></app-field>
              <span i18n="@@einvoice.table.header.total-after-discount" class="block">after Discount</span>
            </th>
            <th class="vat" i18n="@@einvoice.table.header.vat">VAT %</th>
          </tr>
        </thead>
        @for (line of invoiceLines; track line; let i = $index) {
          <tbody class="border-bottom">
            <tr>
              <td class="index"><span class="row-index"><small>{{ lineIdentifier(line, i) }}</small></span></td>
              <td class="description">
                <app-field [document]="line.ItemInformation" path="ItemSellersIdentifier.value"></app-field>
                <app-field [document]="line.ItemInformation" path="ItemBuyersIdentifier.value"></app-field>
                <app-field [document]="line.ItemInformation" path="ItemStandardIdentifier.value"></app-field>
                <app-field [document]="line.ItemInformation" path="ItemName.value"></app-field>
              </td>
              <td class="qty">
                <app-field [document]="line" path="InvoicedQuantity.value" [numberFormat]="numberFormat"></app-field>
              </td>
              <td class="unit">
                <app-field [document]="line" path="InvoicedQuantityUnitOfMeasureCode.value" i18nNamespace="UNECERec20"></app-field>
              </td>
              <td class="unit-price">
                <app-field [document]="line" path="PriceDetails.ItemGrossPrice.value" pathIfEmpty="PriceDetails.ItemNetPrice.value" [numberFormat]="numberFormat"></app-field>
              </td>
              <td class="total">
                <app-field [document]="line" path="InvoicedLineNetAmount.value" [numberFormat]="numberFormat"></app-field>
              </td>
              <td class="vat">
                @if (line.LineVATInformation?.InvoicedItemVATRate?.value) {
                  <app-field [document]="line" path="LineVATInformation.InvoicedItemVATRate.value" [numberFormat]="numberFormat"></app-field>
                }
                @if (!line.LineVATInformation?.InvoicedItemVATRate?.value) {
                  <app-field directValue="{{0 | number:numberFormat}}" [numberFormat]="numberFormat"></app-field>
                }
              </td>
            </tr>
            <tr>
              <td class="index"></td>
              <td class="description" colspan="6">
                <app-field [document]="line.ItemInformation" path="ItemDescription.value"></app-field>
                @for (identifier of line.ItemInformation.ItemClassificationIdentifier; track identifier) {
                  <app-field [document]="identifier" path="value"></app-field>
                }
                @if (line.ItemInformation.ItemCountryOfOrigin) {
                  <div class="inline">
                    <div class="label" i18n="@@einvoice.table.description.country-of-origin">Country of Origin: </div>
                    <app-field [document]="line.ItemInformation" path="ItemCountryOfOrigin.value" i18nNamespace="ISO3166"></app-field>
                  </div>
                }
                @for (attribute of line.ItemInformation?.ItemAttributes ?? []; track attribute) {
                  <div class="inline">
                    <app-field [document]="attribute" path="ItemAttributeName.value"></app-field>:
                    <app-field [document]="attribute" path="ItemAttributeValue.value"></app-field>
                  </div>
                }
                @if (line.ReferencedPurchaseOrderLineReference || line.InvoiceLineBuyerAccountingReference) {
                  <div class="inline">
                    <div class="label" i18n="@@einvoice.table.description.reference">Reference: </div>
                    <app-field [document]="line" path="InvoiceLineObjectIdentifier.schemeID" i18nNamespace="UNCL1153"></app-field>
                    <app-field [document]="line" path="InvoiceLineObjectIdentifier.value"></app-field>
                    <app-field [document]="line" path="ReferencedPurchaseOrderLineReference.value"></app-field>
                    @if (line.ReferencedPurchaseOrderLineReference && line.InvoiceLineBuyerAccountingReference) {
                      <span>, </span>
                    }
                    <app-field [document]="line" path="InvoiceLineBuyerAccountingReference.value"></app-field>
                  </div>
                }
                @if (line.InvoiceLinePeriod) {
                  <div class="inline">
                    <div class="label" i18n="@@einvoice.table.description.performance-period">Performance Period: </div>
                    <app-field [document]="line.InvoiceLinePeriod" path="InvoiceLinePeriodStartDate.value" [dateFormat]="dateFormat"></app-field> -
                    <app-field [document]="line.InvoiceLinePeriod" path="InvoiceLinePeriodEndDate.value" [dateFormat]="dateFormat"></app-field>
                  </div>
                }
                <app-field [document]="line" path="InvoiceLineNote.value"></app-field>
              </td>
            </tr>
            <!-- Discount in % / Price aft dis. -->
            @if (lineHasDiscountPerPrice(line)) {
              <tr>
                <td class="index"></td>
                <td class="description">
                  <div class="inline">
                    <div class="label" i18n="@@einvoice.table.description.discount-in-percent-per-price">Discount abs / Price aft dis.</div>
                  </div>
                </td>
                <td class="qty">
                </td>
                <td class="unit">
                </td>
                <td class="unit-price">
                  <div class="inline">
                    <app-field [document]="line.PriceDetails" path="ItemPriceDiscount.value" [numberFormat]="numberFormat"></app-field>
                  </div>
                </td>
                <td class="total">
                  <app-field [document]="line.PriceDetails" path="ItemNetPrice.value" [numberFormat]="numberFormat"></app-field>
                </td>
                <td class="vat"></td>
              </tr>
            }
            <!-- Price Base -->
            @if (lineHasDiscountPerPrice(line)) {
              <tr>
                <td class="index"></td>
                <td class="description">
                  <div class="label" i18n="@@einvoice.table.description.price-base">Price Base</div>
                </td>
                <td class="qty">
                  <app-field [document]="line.PriceDetails" path="ItemPriceBaseQuantity.value" [numberFormat]="numberFormat"></app-field>
                </td>
                <td class="unit">
                  <app-field [document]="line.PriceDetails" path="ItemPriceBaseQuantityUnitOfMeasureCode.value" i18nNamespace="UNECERec20"></app-field>
                </td>
                <td class="unit-price">
                </td>
                <td class="total">
                </td>
                <td class="vat"></td>
              </tr>
            }
            <!-- Discount in % / abs. -->
            @for (discountLine of invoiceLineAllowances(line); track discountLine) {
              <tr class="discount-line-abs">
                <td class="index"></td>
                <td class="description">
                  <div class="inline">
                    <div class="label">{{getTranslation('einvoice.table.description-line.discount-in-percent-per-abs')}}</div><br />
                    <app-field [document]="discountLine" path="InvoiceLineAllowanceReason.value"></app-field> /
                    <app-field [document]="discountLine" path="InvoiceLineAllowanceReasonCode.value" i18nNamespace="UNCL5189"></app-field>
                  </div>
                </td>
                <td class="qty">
                  <app-field [document]="discountLine" path="InvoiceLineAllowanceBaseAmount.value" [numberFormat]="numberFormat"></app-field>
                </td>
                <td class="unit">
                </td>
                <td class="unit-price">
                  <div class="inline">
                    <app-field [document]="discountLine" path="InvoiceLineAllowancePercentage.value" [numberFormat]="numberFormat" suffix="%">
                    </app-field>
                  </div>
                </td>
                <td class="total">
                  <app-field [document]="discountLine" path="InvoiceLineAllowanceAmount.value" [numberFormat]="numberFormat"></app-field>
                </td>
                <td class="vat">
                </td>
              </tr>
            }
            <!-- Expense in % / abs. -->
            @for (expenseLine of invoiceLineCharges(line); track expenseLine) {
              <tr class="expense-line">
                <td class="index"></td>
                <td class="description">
                  <div class="inline">
                    <div class="label">{{getTranslation('einvoice.table.description-line.expense-in-percent-per-abs')}}</div><br />
                    <app-field [document]="expenseLine" path="InvoiceLineChargeReason.value"></app-field> /
                    <app-field [document]="expenseLine" path="InvoiceLineChargeReasonCode.value" i18nNamespace="UNCL7161"></app-field>
                  </div>
                </td>
                <td class="qty">
                  <app-field [document]="expenseLine" path="InvoiceLineChargeBaseAmount.value" [numberFormat]="numberFormat"></app-field>
                </td>
                <td class="unit">
                </td>
                <td class="unit-price">
                  <div class="inline">
                    <app-field [document]="expenseLine" path="InvoiceLineChargePercentage.value" [numberFormat]="numberFormat" suffix="%"></app-field>
                  </div>
                </td>
                <td class="total">
                  <app-field [document]="expenseLine" path="InvoiceLineChargeAmount.value" [numberFormat]="numberFormat"></app-field>
                </td>
                <td class="vat"></td>
              </tr>
            }
          </tbody>
        }
        <tfoot>
          <tr class="margin-top">
            <td class="index"></td>
            <td class="description" i18n="@@einvoice.table.description.total-net-lines">
              Total Net Lines
            </td>
            <td class="qty">
            </td>
            <td class="unit">
            </td>
            <td class="unit-price">
            </td>
            <td class="total">
              <app-field [document]="document.DocumentTotals" path="SumOfInvoiceLineNetAmount.value" [numberFormat]="numberFormat"></app-field>
            </td>
            <td class="vat">
            </td>
          </tr>
          @if (document.DocumentTotals?.SumOfAllowancesOnDocumentLevel && document.DocumentTotals?.SumOfAllowancesOnDocumentLevel?.value > 0) {
            <tr>
              <td class="index"></td>
              <td class="description" i18n="@@einvoice.table.description.total-discount">
              Total Discount
            </td>
              <td class="qty">
              </td>
              <td class="unit">
              </td>
              <td class="unit-price">
              </td>
              <td class="total">
                <app-field [document]="document.DocumentTotals" path="SumOfAllowancesOnDocumentLevel.value" [numberFormat]="numberFormat"></app-field>
              </td>
              <td class="vat">
              </td>
            </tr>
          }
          @if (document.DocumentTotals?.SumOfChargesOnDocumentLevel && document.DocumentTotals?.SumOfChargesOnDocumentLevel?.value > 0) {
            <tr>
              <td class="index"></td>
              <td class="description" i18n="@@einvoice.table.description.total-expenses">
              Total Expenses
            </td>
              <td class="qty">
              </td>
              <td class="unit">
              </td>
              <td class="unit-price">
              </td>
              <td class="total">
                <app-field [document]="document.DocumentTotals" path="SumOfChargesOnDocumentLevel.value" [numberFormat]="numberFormat"></app-field>
              </td>
              <td class="vat">
              </td>
            </tr>
          }
          <tr>
            <td class="index"></td>
            <td class="horizontal-line" colspan="6">
            </td>
          </tr>
          <tr class="bold margin-top">
            <td class="index"></td>
            <td class="description">
            </td>
            <td class="qty">
              <div class="inline">
                <span i18n="@@einvoice.table.total.title.net">Net</span>
                <app-field [document]="document" path="InvoiceCurrencyCode.value"></app-field>
              </div>
            </td>
            <td class="unit">
            </td>
            <td class="unit-price">
              <div class="inline">
                <span i18n="@@einvoice.table.total.title.vat">VAT</span>
                <app-field [document]="document" path="InvoiceCurrencyCode.value"></app-field>
              </div>
            </td>
            <td class="total">
            </td>
            <td class="vat">
              <div class="inline">
                <span i18n="@@einvoice.table.total.title.gross">Gross</span>
                <app-field [document]="document" path="InvoiceCurrencyCode.value"></app-field>
              </div>
            </td>
          </tr>
          <tr>
            <td class="index"></td>
            <td class="description" i18n="@@einvoice.table.total.title">
              Total
            </td>
            <td class="qty">
              <app-field [document]="document.DocumentTotals" path="InvoiceTotalAmountWithoutVAT.value" [numberFormat]="numberFormat"></app-field>
            </td>
            <td class="unit">
            </td>
            <td class="unit-price">
              <app-field [document]="document.DocumentTotals" path="InvoiceTotalVATAmount.value" [numberFormat]="numberFormat"></app-field>
            </td>
            <td class="total">
            </td>
            <td class="vat">
              <app-field [document]="document.DocumentTotals" path="InvoiceTotalAmountWithVAT.value" [numberFormat]="numberFormat"></app-field>
            </td>
          </tr>
          @for (vatBreakdown of document.VATBreakdown; track vatBreakdown) {
            <tr class="vat-breakdown" [class.hidden]="vatBreakdownHidden(vatBreakdown)">
              <td class="index"></td>
              <td class="description">
                <div class="inline inline-no-space">
                  <span i18n="@@einvoice.table.total.title.vat">VAT</span>
                  <app-field [document]="vatBreakdown" path="VATCategoryRate.value" [numberFormat]="numberFormat" suffix="%"></app-field>&nbsp;
                  @if (vatBreakdown?.VATCategoryCode?.value) {
                    <span i18n="@@einvoice.table.total.title.vat-category">(Category</span>
                    }&nbsp;
                    <app-field [document]="vatBreakdown" path="VATCategoryCode.value"></app-field>
                    @if (vatBreakdown?.VATCategoryCode?.value) {
                      <span>)</span>
                    }
                  </div>
                  @if (vatBreakdown?.VATExemptionReasonText || vatBreakdown?.VATExemptionReasonCode) {
                    <div class="field-with-label">
                      <!-- <div class="label" i18n="@@einvoice.footer.description.tax-exemption-reason">Tax Exemption Reason</div>&nbsp; -->
                      <div class="inline">
                        <app-field [document]="vatBreakdown" path="VATExemptionReasonText.value"></app-field>
                        <app-field [document]="vatBreakdown" path="VATExemptionReasonCode.value"></app-field>
                      </div>
                    </div>
                  }
                </td>
                <td class="qty">
                  <app-field [document]="vatBreakdown" path="VATCategoryTaxableAmount.value" [numberFormat]="numberFormat"></app-field>
                </td>
                <td class="unit">
                </td>
                <td class="unit-price">
                  <app-field [document]="vatBreakdown" path="VATCategoryTaxAmount.value" [numberFormat]="numberFormat"></app-field>
                </td>
                <td class="total">
                </td>
                <td class="vat">
                </td>
              </tr>
            }
            @if (document.DocumentTotals?.PaidAmount && document.DocumentTotals?.PaidAmount?.value > 0) {
              <tr class="border-top border-strong"
                >
                <td class="index"></td>
                <td class="description" i18n="@@einvoice.table.total.title.advanced-payment">
              Advanced Payment
            </td>
                <td class="qty">
                </td>
                <td class="unit">
                </td>
                <td class="unit-price">
                </td>
                <td class="total">
                </td>
                <td class="vat">
                  <app-field [document]="document.DocumentTotals" path="PaidAmount.value" [numberFormat]="numberFormat"></app-field>
                </td>
              </tr>
            }
            @if (document.DocumentTotals?.RoundingAmount && document.DocumentTotals?.RoundingAmount?.value !== 0) {
              <tr>
                <td class="index"></td>
                <td class="description" i18n="@@einvoice.table.total.title.rounding-amount">
              Rounding Amount
            </td>
                <td class="qty">
                </td>
                <td class="unit">
                </td>
                <td class="unit-price">
                </td>
                <td class="total">
                </td>
                <td class="vat">
                  <app-field [document]="document.DocumentTotals" path="RoundingAmount.value" [numberFormat]="numberFormat"></app-field>
                </td>
              </tr>
            }
            @if (document.DocumentTotals?.AmountDueForPayment) {
              <tr class="border-bottom border-strong">
                <td class="index"></td>
                <td class="description" i18n="@@einvoice.table.total.title.due-amount">
              Due Amount
            </td>
                <td class="qty">
                </td>
                <td class="unit">
                </td>
                <td class="unit-price">
                </td>
                <td class="total">
                </td>
                <td class="vat">
                  <app-field [document]="document.DocumentTotals" path="AmountDueForPayment.value" [numberFormat]="numberFormat"></app-field>
                </td>
              </tr>
            }
            @if (document.VATAccountingCurrencyCode) {
              <tr class="border-bottom border-strong">
                <td class="index"></td>
                <td class="description">
                  <div class="inline">
                    <span i18n="@@einvoice.table-discount.header.vat-in-accounting-currency">VAT in </span>
                    <app-field [document]="document" path="VATAccountingCurrencyCode.value"></app-field>
                  </div>
                </td>
                <td class="qty">
                </td>
                <td class="unit">
                </td>
                <td class="unit-price">
                  <app-field [document]="document.DocumentTotals" path="InvoiceTotalVATAmountInAccountingCurrency.value" [numberFormat]="numberFormat"></app-field>
                </td>
                <td class="total">
                </td>
                <td class="vat">
                </td>
              </tr>
            }
            <!-- double line -->
            <tr>
              <td class="index"></td>
              <td colspan="6">
                <div class="doubleline"></div>
              </td>
            </tr>
            @if (discountsAndExpensesHaveValue()) {
              <tr>
                <td class="index"></td>
                <td class="description" i18n="@@einvoice.table-discount.header.description">Details to Reduction and Expense</td>
                <td class="qty ellipsis">
                  @if (!documentLevelAllowanceBaseAmountsAreEmpty) {
                    <div class="inline">
                      <span i18n="@@einvoice.table-discount.header.basic-amount">Basic Amount</span>
                      <app-field class="ml-1" [document]="document" path="InvoiceCurrencyCode.value"></app-field>
                    </div>
                  }
                </td>
                <td class="unit"></td>
                <td class="unit-price">@if (!documentLevelAllowancePercentagesAreEmpty) {
                  <span i18n="@@einvoice.table-discount.header.in-percent">in %</span>
                }</td>
                <td class="total">
                </td>
                <td class="vat">
                  <div class="inline">
                    <span i18n="@@einvoice.table-discount.header.absolute">absolute</span>
                    <app-field class="ml-1" [document]="document" path="InvoiceCurrencyCode.value"></app-field>
                  </div>
                </td>
              </tr>
            }
            @for (allowance of documentLevelAllowances; track allowance) {
              <tr>
                <td class="index"></td>
                <td class="description">
                  <div class="inline">
                    <span i18n="@@einvoice.table-discount.row-head.discount">Reduction</span>
                    <span>/</span>
                    <app-field class="ml-1" [document]="allowance" path="DocumentLevelAllowanceReason.value" suffix=" / "></app-field>
                    <span i18n="@@einvoice.table.total.title.vat">VAT</span>&nbsp;
                    <app-field class="ml-1" [document]="allowance" path="DocumentLevelAllowanceVATRate.value" [numberFormat]="numberFormat" suffix="% "></app-field>
                    @if (allowance?.DocumentLevelAllowanceVATCategoryCode?.value) {
                      <span i18n="@@einvoice.table.total.title.vat-category">(Category</span>
                      }&nbsp;
                      <app-field [document]="allowance" path="DocumentLevelAllowanceVATCategoryCode.value" suffix=")"></app-field>
                      <app-field class="ml-1" [document]="allowance" path="DocumentLevelAllowanceReasonCode.value" i18nNamespace="UNCL5189" prefix=" / "></app-field>
                    </div>
                  </td>
                  <td class="qty">
                    <app-field [document]="allowance" path="DocumentLevelAllowanceBaseAmount.value" [numberFormat]="numberFormat"></app-field>
                  </td>
                  <td class="unit">
                  </td>
                  <td class="unit-price">
                    @if (allowance.DocumentLevelAllowancePercentage?.value) {
                      <div class="inline inline-no-space">
                        <app-field [document]="allowance" path="DocumentLevelAllowancePercentage.value" [numberFormat]="numberFormat" suffix="%"></app-field>
                      </div>
                    }
                  </td>
                  <td class="total">
                  </td>
                  <td class="vat">
                    <app-field [document]="allowance" path="DocumentLevelAllowanceAmount.value" [numberFormat]="numberFormat"></app-field>
                  </td>
                </tr>
              }
              @for (charge of documentLevelCharges; track charge) {
                <tr>
                  <td class="index"></td>
                  <td class="description">
                    <div class="inline">
                      <span i18n="@@einvoice.table-discount.row-head.expense">Expense</span>
                      <span>/</span>
                      <app-field class="ml-1" [document]="charge" path="DocumentLevelChargeReason.value"></app-field>
                      <span i18n="@@einvoice.table.total.title.vat">VAT</span>&nbsp;
                      <app-field class="ml-1" [document]="charge" path="DocumentLevelChargeVATRate.value" [numberFormat]="numberFormat" suffix="% "></app-field>
                      @if (charge?.DocumentLevelChargeVATCategoryCode?.value) {
                        <span i18n="@@einvoice.table.total.title.vat-category">(Category</span>
                      }
                      &nbsp;
                      <app-field [document]="charge" path="DocumentLevelChargeVATCategoryCode.value" suffix=")"></app-field>
                      <app-field class="ml-1" [document]="charge" path="DocumentLevelChargeReasonCode.value" i18nNamespace="UNCL7161" prefix=" / "></app-field>

                    </div>
                  </td>
                  <td class="qty">
                    <app-field [document]="charge" path="DocumentLevelChargeBaseAmount.value" [numberFormat]="numberFormat"></app-field>
                  </td>
                  <td class="unit">
                  </td>
                  <td class="unit-price">
                    @if (charge.DocumentLevelChargePercentage?.value) {
                      <div class="inline inline-no-space">
                        <app-field [document]="charge" path="DocumentLevelChargePercentage.value" [numberFormat]="numberFormat" suffix="%"></app-field>
                      </div>
                    }
                  </td>
                  <td class="total">
                  </td>
                  <td class="vat">
                    <app-field [document]="charge" path="DocumentLevelChargeAmount.value" [numberFormat]="numberFormat"></app-field>
                  </td>
                </tr>
              }
            </tfoot>
          </table>
        </section>
        <section id="additional-fields">
          <!-- Invoice notes -->
          @if (document?.InvoiceNotes?.length > 0) {
            <div class="invoice-notes">
              @for (invoiceNote of document?.InvoiceNotes; track invoiceNote) {
                <div class="invoice-note">
                  <app-field [document]="invoiceNote" path="InvoiceNote.value"></app-field>
                </div>
              }
            </div>
          }
          @if (document.PaymentInstructions?.RemittanceInformation) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.reference">Reference</div>
              <app-field [document]="document" path="PaymentInstructions.RemittanceInformation.value"></app-field>
            </div>
          }
          @if (document.ProjectReference) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.project">Project</div>
              <app-field [document]="document" path="ProjectReference.value"></app-field>
            </div>
          }
          @if (document.ContractReference) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.contract">Contract</div>
              <app-field [document]="document" path="ContractReference.value"></app-field>
            </div>
          }
          @if (document.InvoicedObjectIdentifier) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.objectid">Object ID</div>
              <app-field [document]="document" path="InvoicedObjectIdentifier.value"></app-field>
            </div>
          }
          @if (document.TenderOrLotReference) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.tender-reference">Tender Reference</div>
              <app-field [document]="document" path="TenderOrLotReference.value"></app-field>
            </div>
          }
          @if (document.PurchaseOrderReference) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.buyer-order-reference">Buyer Order Reference</div>
              <app-field [document]="document" path="PurchaseOrderReference.value"></app-field>
            </div>
          }
          @if (document.SalesOrderReference) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.seller-order-reference">Seller Order Reference</div>
              <app-field [document]="document" path="SalesOrderReference.value"></app-field>
            </div>
          }
          @if (document.ReceivingAdviceReference) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.goods-receipt-reference">Goods Receipt Reference</div>
              <app-field [document]="document" path="ReceivingAdviceReference.value"></app-field>
            </div>
          }
          @if (document.DespatchAdviceReference) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.despatch-advice-reference">Despatch Advice Reference</div>
              <app-field [document]="document" path="DespatchAdviceReference.value"></app-field>
            </div>
          }
          @if (document.PrecedingInvoiceReferences) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.preceding-invoice-reference.label">Previous invoice</div>
              <div class="preceding-invoice-references">
                @for (reference of document.PrecedingInvoiceReferences; track reference) {
                  <div class="inline-no-space">
                    <app-field [document]="reference" path="PrecedingInvoiceReference.value"></app-field>
                    <span>, </span>
                    <app-field [document]="reference" path="PrecedingInvoiceIssueDate.value" [dateFormat]="dateFormat"></app-field>
                  </div>
                }
              </div>
            </div>
          }
          <br />
          @if (document.PaymentTerms) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.payment-terms">Payment Terms</div>
              <app-field [document]="document" path="PaymentTerms.value"></app-field>
            </div>
          }
          @if (document.PaymentInstructions?.PaymentMeansTypeCode || document.PaymentInstructions?.PaymentMeansText) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.payment-method">Payment Method</div>
              <div class="inline">
                <app-field [document]="document" path="PaymentInstructions.PaymentMeansTypeCode.value" i18nNamespace="UNCL4461">, </app-field>
                <app-field [document]="document" path="PaymentInstructions.PaymentMeansText.value"></app-field>
              </div>
            </div>
          }
          @if (document.PaymentInstructions?.CreditTransfer || document.PaymentInstructions?.CreditTransfer?.length > 0) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.account-information">Account Information</div>
              <div class="account-informations">
                @for (account of document.PaymentInstructions.CreditTransfer; track account) {
                  <div class="inline">
                    <app-field [document]="account" path="PaymentAccountName.value"> </app-field>
                    <app-field [document]="account" path="PaymentAccountIdentifier.value"> </app-field>
                    <app-field [document]="account" path="PaymentServiceProviderIdentifier.value"></app-field>
                  </div>
                }
              </div>
            </div>
          }
          @if (document.PaymentInstructions?.DirectDebit) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.direct-debit">SEPA direct debit </div>
              <div class="inline">
                <app-field [document]="document" path="PaymentInstructions.DirectDebit.DebitedAccountIdentifier.value"></app-field>
                <span>/</span>
                <app-field [document]="document" path="PaymentInstructions.DirectDebit.MandateReferenceIdentifier.value"></app-field>
              </div>
            </div>
          }
          @if (document.PaymentInstructions?.PaymentCardInformation) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.bank-card">Bank card</div>
              <div class="inline">
                <app-field [document]="document" path="PaymentInstructions.PaymentCardInformation.PaymentCardPrimaryAccountNumber.value"></app-field>
                <span>/</span>
                <app-field [document]="document" path="PaymentInstructions.PaymentCardInformation.PaymentCardHolderName.value"></app-field>
              </div>
            </div>
          }

          @if (document.BuyerAccountingReference) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.accounting-reference">Accounting Reference</div>
              <app-field [document]="document" path="BuyerAccountingReference.value"></app-field>
            </div>
          }
          @if (document.Seller?.SellerIdentifier?.[0]) {
            <div class="field-with-label">
              <div class="label" i18n="@@einvoice.footer.description.seller-identifier">Seller identifier</div>
              <app-field [document]="document" path="Seller.SellerIdentifier[0].value"></app-field>
            </div>
          }
          <!-- <div class="field-with-label" *ngIf="document.ProcessControl?.BusinessProcessType">
          <div class="label" i18n="@@einvoice.footer.description.business-process-type">Business Process Type</div>
          <app-field [document]="document" path="ProcessControl.BusinessProcessType.value"></app-field>
        </div>
        <div class="field-with-label" *ngIf="document.ProcessControl?.SpecificationIdentifier">
          <div class="label" i18n="@@einvoice.footer.description.spec-id">Spec ID</div>
          <app-field [document]="document" path="ProcessControl.SpecificationIdentifier.value"></app-field>
        </div> -->
        <br />
        @if (attachments) {
          <div class="field-with-label">
            <div class="label" i18n="@@einvoice.footer.description.attachment">Attachments</div>
            <div class="attachment-items">
              @for (attachment of attachments; track attachment) {
                <div
                  class="attachment-item"
                  [class.einvoice-field-selectable]="true"
                  [class.einvoice-field-selected]="isAttachmentSelected(attachment)"
                  [class.einvoice-field-active]="isAttachmentActive(attachment)"
                  (click)="selectAndDownloadAttachment($event, attachment)">
                  <a href="#"><app-field [directValue]="attachment.SupportingDocumentReference?.value"></app-field></a>
                  <app-field [directValue]="attachment.SupportingDocumentDescription?.value"></app-field>
                </div>
              }
            </div>
          </div>
        }
      </section>

    </tbody>
    <tfoot>
      <section id="footer">
        <app-field [document]="document" path="Seller.SellerName.value"></app-field>
        <app-field [document]="document" path="Seller.SellerTradingName.value"></app-field>
        <app-field [document]="document" path="Seller.SellerPostalAddress.AddressLine1.value"></app-field>
        <app-field [document]="document" path="Seller.SellerPostalAddress.AddressLine2.value"></app-field>
        <app-field [document]="document" path="Seller.SellerPostalAddress.AddressLine3.value"></app-field>
        <span class="inline">
          <app-field [document]="document.Seller.SellerPostalAddress" path="PostCode.value"></app-field>
          <app-field [document]="document.Seller.SellerPostalAddress" path="City.value"></app-field>
        </span>
        <app-field [document]="document" path="Seller.SellerPostalAddress.CountrySubdivision.value"></app-field>
        <app-field [document]="document" path="Seller.SellerPostalAddress.CountryCode.value" i18nNamespace="ISO3166"></app-field>
        @if (document?.Seller?.SellerTaxRegistrationIdentifier?.value) {
          <span class="inline">
            <span>{{getTranslation('einvoice.footer.description.taxid')}}</span>
            <app-field [document]="document" path="Seller.SellerTaxRegistrationIdentifier.value"></app-field>
          </span>
        }
        @if (document?.Seller?.SellerVATIdentifier?.value) {
          <span class="inline">
            <span>{{getTranslation('einvoice.footer.description.uid')}}</span>
            <app-field [document]="document" path="Seller.SellerVATIdentifier.value"></app-field>
          </span>
        }
        @if (document?.Seller?.SellerAdditionalLegalInformation?.value) {
          <app-field [document]="document" path="Seller.SellerAdditionalLegalInformation.value"></app-field>
        }
        @if (document?.Seller?.SellerLegalRegistrationIdentifier?.value) {
          <app-field [document]="document" path="Seller.SellerLegalRegistrationIdentifier.value"></app-field>
        }
        @if (document?.Seller?.SellerElectronicAddress?.value) {
          <app-field [document]="document" path="Seller.SellerElectronicAddress.value"></app-field>
        }
      </section>

    </tfoot>
  </table>

